<p>instant-monitor works!</p>
